const {
  ensureIterable
} = require('../../internal/iterable.js');

const {
  Peekerator
} = require('../../internal/peekerator.js');

function __peekerate(source) {
  return Peekerator.from(source);
}

exports.__peekerate = __peekerate;

function wrapWithEnsureIterable(fn) {
  return source => fn(ensureIterable(source));
}

const peekerate = wrapWithEnsureIterable(__peekerate);
exports.peekerate = peekerate;